import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-primary bg-accent hover:bg-accent-hover shadow-lg shadow-accent/30 border border-accent-strong/50',
  secondary: 'text-white bg-secondary hover:bg-secondary-hover shadow-lg shadow-secondary/25 border border-secondary'
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg tracking-wide transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-primary ${variantClasses[variant]}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-41" data-mp="i11t2jfs2orp">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-42" data-mp="3uizyxktiyapl">
      {children}
    </motion.button>;
}